import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
export var icon = /*#__PURE__*/css(["width:", ";height:", ";"], pxToRem(36), pxToRem(36));
export var container = /*#__PURE__*/css(["display:flex;justify-content:space-between;max-width:", ";margin:0 auto;"], pxToRem(280));